import { Environment } from "@react-three/drei/core/Environment";
import { Lightformer } from "@react-three/drei/core/Lightformer";
import { BackSide } from "three";
function StudioEnvironment() {
  return <Environment resolution={256}>
      {
    /*
      Enclosing sky. Without it every metallic surface reflects black, because
      lightformers alone leave most of the environment unlit — which is what turns
      silver paint and alloy wheels into dark blobs.
    */
  }
      <mesh scale={60}>
        <sphereGeometry args={[1, 32, 16]} />
        <meshBasicMaterial color="#c3cdd9" side={BackSide} toneMapped={false} />
      </mesh>
      {
    /* darker floor half, so the lower bodywork picks up a grounded reflection */
  }
      <Lightformer
    form="rect"
    intensity={0.4}
    color="#8892a0"
    position={[0, -8, 0]}
    rotation={[-Math.PI / 2, 0, 0]}
    scale={[50, 50, 1]}
  />

      {
    /* broad softbox overhead */
  }
      <Lightformer
    form="rect"
    intensity={3.4}
    color="#ffffff"
    position={[0, 7, 0]}
    rotation={[Math.PI / 2, 0, 0]}
    scale={[16, 9, 1]}
  />
      {
    /* length-wise strips: the highlight lines along the flanks */
  }
      <Lightformer
    form="rect"
    intensity={2.6}
    color="#eef4ff"
    position={[0, 3.2, -8]}
    rotation={[0, 0, 0]}
    scale={[18, 1.8, 1]}
  />
      <Lightformer
    form="rect"
    intensity={2.6}
    color="#eef4ff"
    position={[0, 3.2, 8]}
    rotation={[0, Math.PI, 0]}
    scale={[18, 1.8, 1]}
  />
      {
    /* key from the front three-quarter, warm bounce from behind */
  }
      <Lightformer
    form="rect"
    intensity={2.2}
    color="#ffffff"
    position={[10, 4, 4]}
    rotation={[0, -Math.PI / 2.4, 0]}
    scale={[9, 4, 1]}
  />
      <Lightformer
    form="ring"
    intensity={1.4}
    color="#ffd9b3"
    position={[-9, 2.6, -3]}
    rotation={[0, Math.PI / 2, 0]}
    scale={5}
  />
    </Environment>;
}
export {
  StudioEnvironment
};
